import { Trans, useLingui } from '@lingui/react/macro';
import { memo } from 'react';

import { Alert } from '@/components/Alert';
import {
  createDocumentUploadAdapter,
  FileUpload,
} from '@/components/fileUpload';
import { llamaAcceptFiles } from '@/components/fileUpload/llamaAcceptFiles';
import { trpc } from '@/services/trpc';

export type UploadDocumentsProps = {
  chatIds: string[];
  limitReached: boolean;
  projectedLimitReached: boolean;
};

export const UploadDocuments = memo(function UploadDocuments({
  chatIds,
  limitReached,
  projectedLimitReached,
}: UploadDocumentsProps) {
  const { t } = useLingui();
  const utils = trpc.useUtils();
  const uploadAdapter = createDocumentUploadAdapter(chatIds, () =>
    utils.chats.findAll.invalidate(),
  );

  return (
    <div className='flex h-full flex-col justify-between gap-4'>
      {limitReached && (
        <Alert
          variant='warning'
          title={t`Document Limit Reached`}
          className='mb-4'
        >
          <Trans>
            You have reached the maximum document limit for your plan. File
            upload is disabled.
          </Trans>
        </Alert>
      )}

      <div className='grow'>
        <FileUpload
          uploadAdapter={uploadAdapter}
          accept={llamaAcceptFiles}
          maxSize={50 * 1024 * 1024}
          disabled={limitReached || projectedLimitReached}
        />
      </div>
    </div>
  );
});
